import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, useIntl } from 'react-intl'
import { Typography } from '@material-ui/core'
import { useSelector, useDispatch } from 'react-redux'
import useTransfer from 'commons/useTransfer'
import ConfirmWithPasswordDialog from './ConfirmWithPasswordDialog'
import ConfirmWithOtpDialog from './ConfirmWithOtpDialog'
import useOtp from 'commons/useOtp'
import { useRreloadProfile } from 'app/main/userProfile/UpdateLocalAdminProfile'
import MessageAlert from 'app/components/MessageAlert'

const TransferWithPasswordOrOTP = (props) => {
  const { id, name, email } = props
  const { data: userInfo } = useSelector(({ auth }) => auth.user)

  const { formatMessage } = useIntl()
  const { createButton } = useTransfer()
  const [createLoading, create] = createButton()
  const onReloadProfile = useRreloadProfile()
  const [isOpenPassword, setIsOpenPassword] = useState(false)
  const [isOpenOtp, setIsOpenOtp] = useState(false)
  const [isLoading, setIsLoading] = useState(createLoading)
  const dispatchSystem = useDispatch()

  const {
    state: { isLoading: isOtpLoading, refCode, error },
    requestOtp,
    reRequestOtp,
    transferAccount,
    clearStateOtp,
  } = useOtp()

  const handleConfirmPasswordOpen = () => {
    setIsOpenPassword(true)
  }

  const handleConfirmPasswordClose = () => {
    setIsOpenPassword(false)
  }

  const handleConfirmOtpOpen = async () => {
    setIsOpenOtp(true)
    await requestOtp({ email, action: 'transfer' })
  }

  const reSendOtp = async () => {
    await reRequestOtp({ email, action: 'transfer' })
  }

  const handleConfirmOtpClose = () => {
    clearStateOtp()
    setIsOpenOtp(false)
  }

  const handleConfirmWithPasswordSubmit = async (
    id,
    password,
    setFieldError,
  ) => {
    try {
      setIsLoading(true)
      await transferAccount({
        email,
        password,
        inviteeId: id,
        type: 'password',
      })

      onReloadProfile()
      setIsOpenPassword(false)
      setIsLoading(false)
    } catch {
      setFieldError(
        'password',
        formatMessage({
          id: 'transfer.error.401',
        }),
      )
      setIsLoading(false)
    }
  }

  const handleConfirmWithOtpSubmit = async (code) => {
    try {
      setIsLoading(true)
      await transferAccount({
        email,
        ref: refCode,
        otp: code,
        inviteeId: id,
        type: 'otp',
      })
      onReloadProfile()
      setIsOpenOtp(false)
      setIsLoading(false)
    } catch {
      dispatchSystem(
        MessageAlert.showError({
          message: formatMessage({
            id: 'teamMembers.otp.incorrect',
          }),
        }),
      )
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (createLoading) setIsLoading(createLoading)
    else setIsLoading(false)
  }, [createLoading])

  return (
    <>
      <div className="flex space-x-2 items-center">
        <Typography className="text-14 text-primary p-0 font-bold space-x-2">
          <FormattedMessage id="teamMembers.transferByPassworOrOtp.label" />
        </Typography>
        {userInfo.hasPassword && (
          <>
            <div
              className="text-14 text-primary normal-case p-0 text-secondary underline cursor-pointer"
              onClick={handleConfirmPasswordOpen}
            >
              {formatMessage({
                id: 'login.textField.placeHolder.password',
              })}
            </div>
            <Typography className="text-14 text-primary p-0 font-bold">
              <FormattedMessage id="notification.timeline.or" />
            </Typography>
          </>
        )}

        <div
          className="text-14 text-primary normal-case p-0 text-secondary underline cursor-pointer"
          onClick={handleConfirmOtpOpen}
        >
          OTP
        </div>
      </div>
      <ConfirmWithPasswordDialog
        open={isOpenPassword}
        isLoading={isLoading}
        name={name}
        error={error}
        onClose={handleConfirmPasswordClose}
        onSubmit={(password, setFieldError) =>
          handleConfirmWithPasswordSubmit(id, password, setFieldError)
        }
      />
      <ConfirmWithOtpDialog
        open={isOpenOtp}
        isLoading={isLoading}
        isOtpLoading={isOtpLoading}
        name={name}
        email={email}
        refCode={refCode}
        reSendOtp={reSendOtp}
        onClose={handleConfirmOtpClose}
        error={error}
        onSubmit={(code) => handleConfirmWithOtpSubmit(code)}
      />
    </>
  )
}

TransferWithPasswordOrOTP.propTypes = {
  id: PropTypes.number,
  name: PropTypes.string,
}

export default TransferWithPasswordOrOTP
